import { JobRouteName } from '.';
import { AppRouteConfig, breadcrumbs } from '..';
import { Breadcrumb } from '../../types';

export function jobManageApplicationsRoutes(
	routeName: JobRouteName,
	listBreadcrumb: Breadcrumb | undefined,
): Array<AppRouteConfig> {
	return [
		{
			path: ':id/applications',
			component: {
				render: c => c('router-view'),
			},
			meta: {
				caslSubject: 'jobs.manage_applications',
				caslAction: 'view',
			},
			children: [
				{
					path: '',
					name: routeName + JobRouteName.jobApplicationList,
					component: () =>
						import('../../views/job/application/JobApplicationList.vue'),
					meta: {
						breadcrumbs: [
							breadcrumbs.get('home'),
							listBreadcrumb,
							breadcrumbs.get('jobApplications'),
						],
					},
				},
				{
					path: 'search-contact/:condition',
					name: routeName + JobRouteName.jobApplicationListContactSearchList,
					component: () =>
						import(
							'../../views/job/application/NewJobApplicationContactSearch.vue'
						),
					meta: {
						breadcrumbs: [
							breadcrumbs.get('home'),
							listBreadcrumb,
							breadcrumbs.get('jobApplications'),
							breadcrumbs.get('addJobApplicationContactSearch'),
						],
						caslSubject: 'jobs.manage_applications',
						caslAction: 'edit',
					},
				},
				{
					path: 'scan-profile',
					name: routeName + JobRouteName.jobApplicationListScanProfile,
					component: () =>
						import(
							'../../views/job/application/NewJobApplicationScanProfile.vue'
						),
					meta: {
						breadcrumbs: [
							breadcrumbs.get('home'),
							listBreadcrumb,
							breadcrumbs.get('jobApplications'),
							breadcrumbs.get('jobApplicationScanProfile'),
						],
						caslSubject: 'jobs.manage_applications',
						caslAction: 'edit',
					},
				},
				{
					path: 'new',
					name: routeName + JobRouteName.jobApplicationNewApplication,
					component: () =>
						import('../../views/job/application/NewJobApplication.vue'),
					meta: {
						breadcrumbs: [
							breadcrumbs.get('home'),
							listBreadcrumb,
							breadcrumbs.get('jobApplications'),
							breadcrumbs.get('addJobApplication'),
						],
						caslSubject: 'jobs.manage_applications',
						caslAction: 'edit',
					},
				},
				{
					path: ':profileId',
					name: routeName + JobRouteName.jobApplicationNewContactApplication,
					component: () => import('../../views/contact/ContactApplication.vue'),
					meta: {
						breadcrumbs: [
							breadcrumbs.get('home'),
							listBreadcrumb,
							breadcrumbs.get('jobApplications'),
							breadcrumbs.get('contactApplicationDetails'),
						],
						caslSubject: 'contacts.applications',
						caslAction: 'view',
					},
				},
			],
		},
	];
}
